import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    // 모달이 닫히면 hash가 사라지는데 이 때는 스크롤이 일어나지 말아야 함
    if (from.path === to.path && from.hash && !to.hash) {
      return
    }

    // 원래라면 저장된 위치로 이동시켜야하나 현재는 DYDefault가 
    // if (savedPosition) {
    //   return savedPosition
    // }

    if (to.hash && to.path == from.path) {
      try {
        const el = document.querySelector(to.hash)
        if (el && el instanceof HTMLElement) {
          return { top: el.offsetTop, left: 0, behavior: "smooth" }
        }
      } catch (e: any) {
        return
      }

      return
    }

    // return {
    //   top: 0,
    //   left: 0
    // }
  }
}